<div class="">
  <h2>Your invite has been removed.</h2>

  @if (redemptionMessage) {
    <div class="redemption-text mt-2">
      <p class="text-danger">
        {{ redemptionMessage }}
      </p>
    </div>
  }
  @if (redemptionMessage === "No invite code found in the URL." || testing) {
    <div class="text-center m-3">
      <button class="btn btn-primary btn-block">Sign Up</button>
    </div>
  }
</div>
